<template>
  <balance-info
    :balance="balance"
    :no-margin="noMargin"
    :open-withdraw-dialog="openWithdrawDialog"
    :open-bank-account-to-send-balance-dialog="openBankAccountToSendBalanceDialog"
    :value-waiting-to-be-received="waitingToBeReceived"
    :hide-action-for-roles="[roles.appRoles.ANALYST]"
  />
  <entry-wizard-dialog
    ref="entryWizardDialog"
    :on-change="refreshTopbar"
  />
  <show-for-permission :permission="permissions.OperationBalanceWithdrawal">
    <withdraw-dialog
      ref="withdrawDialog"
      :on-change="refresh"
    />
  </show-for-permission>
</template>

<script>
import BalanceInfo from '@/apps/payments/payments/statement/components/presentational/BalanceInfo.vue';
import WithdrawDialog from '@/apps/payments/payments/statement/components/presentational/WithdrawDialog.vue';
import statementResource from '@/apps/payments/payments/statement/resources/statement';
import { getMessage } from '@/commons/services/error';
import EntryWizardDialog from '@/apps/payments/payments/statement/components/presentational/EntryWizardDialog.vue';
import { roles } from '@transfeeradev/api-enums';
import ShowForPermission from '@/commons/components/container/ShowForPermission.vue';
import { permissions } from '@/commons/resources/loggedUser';

export default {
  name: 'balance-info-container',
  components: {
    BalanceInfo,
    WithdrawDialog,
    EntryWizardDialog,
    ShowForPermission
  },
  props: {
    noMargin: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  emits: ['refresh'],
  data: () => ({
    balance: 0,
    waitingToBeReceived: 0,
    roles,
    permissions
  }),
  created() {
    return this.refresh();
  },
  methods: {
    refreshTopbar() {
      window.dispatchEvent(new Event('topbar.refresh'));
    },
    refresh() {
      return statementResource.getBalance().then(
        balance => {
          this.balance = balance && balance.value;
          this.waitingToBeReceived = balance && balance.waiting_value;
          this.$emit('refresh');
        },
        error => this.$toaster.error(getMessage(error))
      );
    },
    openWithdrawDialog() {
      this.$refs.withdrawDialog.open();
    },
    openBankAccountToSendBalanceDialog() {
      this.$refs.entryWizardDialog.open();
    }
  }
};
</script>
